export default "https://cdn-static.gokick.com/assets/5d59d840aa8978759fe32f9d0593dfb9088da5d0/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";